export default __webpack_public_path__ + "static/media/355.ea24638a.png";